import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './AuthContext';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './services/msalInstance';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    background: {
      default: '#f4f6f8',
    },
  },
});

// Initialize MSAL and handle redirect response
msalInstance.initialize()
  .then(() => {
    return msalInstance.handleRedirectPromise();
  })
  .then((response) => {
    if (response) {
      console.log('Authentication successful after redirect:', response);
      
      const account = response.account;
      const loginType = localStorage.getItem("office365LoginType");
      
      if (account) {
        const email = account.username;
        const name = account.name;
        
        if (loginType === "student") {
          // Handle student Office 365 login
          localStorage.setItem("studentEmail", email);
          localStorage.setItem("studentName", name);
          localStorage.setItem("office365StudentLoginPending", "true");
          localStorage.removeItem("office365LoginType");
        } else {
          // Handle teacher Office 365 login (default)
          localStorage.setItem("teacherEmail", email);
          localStorage.setItem("teacherName", name);
          localStorage.setItem("office365LoginPending", "true");
          localStorage.removeItem("office365LoginType");
        }
      }
    }
    // Render the app after MSAL is initialized and redirect is handled
    renderApp();
  })
  .catch((error) => {
    console.error('MSAL initialization or redirect handling failed:', error);
    // Still render the app even if there's an error
    renderApp();
  });

function renderApp() {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <MsalProvider instance={msalInstance}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
          }}
        >
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </MsalProvider>
  );
}

